<template>
  <search-service />
</template>
<script>
import searchService from '@/pages/search/searchService'

import Util from 'assets/javascripts/util'
import Promise from 'bluebird'

// nuxt.config.jsに書いてもグローバルに効かなかったのでローカルで設定する
Promise.config({ cancellation: true })

export default {
  name: 'categories',
  components: {
    searchService
  },
  validate({ params }) {
    // 数値でなければならない
    return /^\d+$/.test(params.categoryId)
  }
}
</script>
